<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <SSO :external-name="partnerShortName"/>
    </v-row>
  </v-container>
</template>

<script>
import SSO from "@/views/Embed/components/SSO.vue";

export default {
  name: "SSOEmbed",
  components: {SSO},
  props: {
    partnerShortName: String,
  },
}
</script>

<style scoped>

</style>